import { render } from "./AddQuestion.vue?vue&type=template&id=0b5935ba&scoped=true"
import script from "./AddQuestion.vue?vue&type=script&lang=js"
export * from "./AddQuestion.vue?vue&type=script&lang=js"

import "./AddQuestion.vue?vue&type=style&index=0&id=0b5935ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5935ba"]])

export default __exports__